module.exports = __webpack_public_path__ + "media/images/checkmark-square-40929cafb78019ee6007e93abb92f00a.svg";